import {useMemo} from 'react';
import {
  RELATED_PRODUCTS_TAB_KEY_BUDGET_FRIENDLY,
  RELATED_PRODUCTS_TAB_KEY_MORE_FITS_AND_SIZES,
  RELATED_PRODUCTS_TAB_KEY_MORE_FROM_THIS_BRAND,
  RELATED_PRODUCTS_TAB_KEY_YOU_MAY_ALSO_LIKE,
  RELATED_PRODUCTS_TABS
} from 'constants/pdpRelatedProducts';
import {filterByCategory} from './useRelatedProductsData';

export default function useRelatedProductsTabs({
  brand,
  isApparel,
  isRecoBrandProductsFetched,
  isRecommendationsProductsFetched,
  isRelatedProductsFetched,
  primaryCategoryId,
  recoBrandProducts,
  recommendations,
  relatedProducts
}) {
  const tabsToShow = useMemo(
    () =>
      Object.values(RELATED_PRODUCTS_TABS).filter(({value}) => {
        if (value === RELATED_PRODUCTS_TAB_KEY_YOU_MAY_ALSO_LIKE) {
          return (
            !isRecommendationsProductsFetched ||
            recommendations?.related_products?.length > 0
          );
        }
        if (value === RELATED_PRODUCTS_TAB_KEY_MORE_FITS_AND_SIZES) {
          if (isApparel) {
            return (
              !isRelatedProductsFetched ||
              relatedProducts?.complements?.length > 0
            );
          }
          return false;
        }
        if (value === RELATED_PRODUCTS_TAB_KEY_MORE_FROM_THIS_BRAND) {
          return recoBrandProducts?.brand_products?.length > 0;
        }
        const filteredProducts = filterByCategory(
          recommendations?.related_products,
          primaryCategoryId
        );
        return (
          !isRecommendationsProductsFetched || filteredProducts?.length > 0
        );
      }),
    [
      brand,
      isApparel,
      isRecommendationsProductsFetched,
      recommendations,
      isRelatedProductsFetched,
      relatedProducts,
      primaryCategoryId,
      isRecoBrandProductsFetched
    ]
  );

  const tabOrder = useMemo(() => {
    return [
      RELATED_PRODUCTS_TAB_KEY_YOU_MAY_ALSO_LIKE,
      RELATED_PRODUCTS_TAB_KEY_BUDGET_FRIENDLY,
      ...[
        RELATED_PRODUCTS_TAB_KEY_MORE_FROM_THIS_BRAND,
        RELATED_PRODUCTS_TAB_KEY_MORE_FITS_AND_SIZES
      ].sort(() => Math.random() - 0.5)
    ];
  }, []);

  const tabs = useMemo(() => {
    return tabsToShow.sort((a, b) => {
      return tabOrder.indexOf(a.value) - tabOrder.indexOf(b.value);
    });
  }, [tabsToShow, tabOrder]);

  return {
    tabOrder,
    tabs,
    tabsToShow
  };
}
